import Client from './Clients/AxiosClient'
import { parseFilters } from './utils/ParseFilters'
const resource = 'projects'

export default {
  get (filters) {
    return Client.get(`${resource}?${parseFilters(filters)}`)
      .then(response => response.data)
  },
  getProjectsPost (payload) {
    return Client.post(`${resource}/get/get_projects_post`, parseFilters(payload))
      .then(response => response.data)
  },
  getProject (id, filters) {
    return Client.get(`${resource}/${id}?${parseFilters(filters)}`)
      .then(response => response.data)
  },
  create (payload) {
    return Client.post(`${resource}`, payload)
      .then(response => response.data)
  },
  update (payload, id) {
    return Client.put(`${resource}/${id}`, payload)
      .then(response => response.data)
  },
  delete (id) {
    return Client.delete(`${resource}/${id}`)
      .then(response => response.data)
  },
  createProjectMetum (payload, id) {
    return Client.post(`projects/${id}/project_meta/`, payload)
      .then(response => response.data)
  },
  updateProjectMetum (payload, id, pmId) {
    return Client.put(`projects/${id}/project_meta/${pmId}`, payload)
      .then(response => response.data)
  },
  createSalesRepProjectMetum (payload, id) {
    return Client.post(`projects/${id}/sales_rep_project_meta/`, payload)
      .then(response => response.data)
  },
  updateSalesRepProjectMetum (payload, id, srpmId) {
    return Client.put(`projects/${id}/sales_rep_project_meta/${srpmId}`, payload)
      .then(response => response.data)
  },
  upcomingSubmissions (year, limit=50, parentId='') {
    return Client.get(`${resource}/upcoming/submissions/${year}?limit=${limit}&parentId=${parentId}`)
      .then(response => response.data)
  }
}
